/* 
  Universal Reusable Pagination Engine
  Works on: Tables (tr), Grids (div), Lists (li), etc.
  Usage: Add data-pagination="items-per-page" to any container (table, div, ul)
*/
class SimplePagination {
  constructor() {
    // Select any element with the data-pagination attribute
    this.containers = document.querySelectorAll('[data-pagination]');
    this.init();
  }

  init() {
    if (this.containers.length === 0) return;

    this.containers.forEach((container, index) => {
      const itemsPerPage = parseInt(container.getAttribute('data-pagination')) || 50;
      
      // Determine what to paginate based on the container type
      let items = [];
      const tagName = container.tagName.toLowerCase();

      if (tagName === 'table') {
        // For tables, target tbody rows
        const tbody = container.querySelector('tbody');
        if (tbody) {
          items = Array.from(tbody.querySelectorAll('tr'));
        } else {
          items = Array.from(container.querySelectorAll('tr'));
        }
      } else if (tagName === 'ul' || tagName === 'ol') {
        // For lists, target li
        items = Array.from(container.querySelectorAll('li'));
      } else {
        // For divs/grids, target direct children that aren't scripts/templates
        // You can customize this selector if needed, e.g., '.product-card'
        items = Array.from(container.children);
      }

      // Skip if items are fewer than limit
      if (items.length <= itemsPerPage) return;

      const totalPages = Math.ceil(items.length / itemsPerPage);
      const controlsId = `sp-controls-${index}`;
      
      // Create Controls Container
      const controls = document.createElement('div');
      controls.id = controlsId;
      controls.className = 'simple-pagination-controls';
      controls.style.cssText = 'margin-top:15px; text-align:center; display:flex; justify-content:center; gap:10px; align-items:center; flex-wrap:wrap;';
      
      controls.innerHTML = `
        <button class="sp-prev" disabled style="padding:8px 16px; cursor:pointer;">Previous</button>
        <span class="sp-indicator" style="font-weight:bold;">Page 1 of ${totalPages}</span>
        <button class="sp-next" style="padding:8px 16px; cursor:pointer;">Next</button>
      `;

      // Insert controls after the container
      container.parentNode.insertBefore(controls, container.nextSibling);

      // State
      let currentPage = 1;

      const updatePage = (page) => {
        const start = (page - 1) * itemsPerPage;
        const end = start + itemsPerPage;

        items.forEach((item, i) => {
          if (i >= start && i < end) {
            item.style.display = ''; // Reset to default (table-row, block, list-item, etc.)
            // Optional: Add a class for animation
            item.classList.add('sp-visible');
          } else {
            item.style.display = 'none';
            item.classList.remove('sp-visible');
          }
        });

        // Update UI
        const prevBtn = controls.querySelector('.sp-prev');
        const nextBtn = controls.querySelector('.sp-next');
        const indicator = controls.querySelector('.sp-indicator');

        prevBtn.disabled = page === 1;
        nextBtn.disabled = page === totalPages;
        indicator.textContent = `Page ${page} of ${totalPages}`;
      };

      // Event Listeners
      controls.querySelector('.sp-prev').addEventListener('click', () => {
        if (currentPage > 1) {
          currentPage--;
          updatePage(currentPage);
        }
      });

      controls.querySelector('.sp-next').addEventListener('click', () => {
        if (currentPage < totalPages) {
          currentPage++;
          updatePage(currentPage);
        }
      });

      // Initialize: Hide all first, then show page 1
      items.forEach(item => item.style.display = 'none');
      updatePage(1);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SimplePagination();
});